import React, { useState, useMemo, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import componentFunctions from '../../../../../services/tools/componentFunctions';
import * as tnaServices from '../../../../../services/tnaServices';
import css from './TnaOverview.module.css';

import toShort from '../../../../../services/utils/dateParser';
import SearchBar from '../../../_common/elements/search-bar/SearchBar';

// const seed = [
//     {
//         tnaId: 1,
//         tnaTitle: 'Test1',
//         tnaRevNo: '1'
//     },
//     {
//         tnaId: 2,
//         tnaTitle: 'Test2',
//         tnaRevNo: '1'
//     }
// ]

function TnaOverview() {
    const [filter, setFilter] = useState('');
    const [data, setData] = useState([]);
    const [sortConfig, setSortConfig] = useState(componentFunctions.sortConfig);
    const requestSort = (key) => componentFunctions.requestSort(key, sortConfig, setSortConfig);
    const navigate = useNavigate();

    useEffect(() => {
        tnaServices
            .getAll(1)
            .then((res) => {
                // console.log(res);
                setData(res.data);
            })
            .catch((err) => {
                console.error('Error fetching certificate issue data:', err);
            });
    }, []);

    const sortedAndFilteredData = useMemo(() => {
        return componentFunctions.sortedAndFilteredData(data, sortConfig, filter);
    }, [data, sortConfig, filter]);

    if (!data || !data.length) {
        return <p>No data available.</p>;
    }

    // ---------------------------------------
    const headers = Object.keys(data[0]);
    //-------------------------------------

    // console.log(caller);

    return (
        <>
            <SearchBar filter={filter} setFilter={setFilter} sortedAndFilteredData={sortedAndFilteredData} />
            {/* <div style={{ textAlign: 'right', marginTop: '5px', color: 'red', fontSize: '1.2rem' }}>
                <label>
                    Show Closed?
                    <input type="checkbox" onChange={handleShowClosedFilter} value={showClosed} />
                </label>
                <label>
                    Show Cancelled?
                    <input type="checkbox" onChange={handleShowCancelledFilter} value={showCancelled} />
                </label>
            </div> */}
            <h2>TNAs</h2>
            {/* tnaId, tnaNo, tnaTitle, aircraftTypeId, licenseCategoryId, tnaDescription, tnaPrerequisites, tnaTerminalLO, tnaReferenceDocuments, tnaMinAttendance, tnaMaxDayHours, tnaRev, tnaRevDate, tnaCreated, tnaModified */}
            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        <th onClick={() => requestSort(data.tnaId)} className={css.th}>
                            TNA ID
                            {/* {sortConfig.key === data.courseNo ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.tnaNo)} className={css.th}>
                            TNA No
                            {/* {sortConfig.key === data.courseNo ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.tnaTitle)} className={css.th}>
                            Title
                            {/* {sortConfig.key === data.studentNo ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.aircraftTypeId)} className={css.th}>
                            A/C type
                            {/* {sortConfig.key === data.studentName ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.licenseCategoryId)} className={css.th}>
                            Cat
                            {/* {sortConfig.key === data.studentName ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.tnaRev)} className={css.th}>
                            Rev
                            {/* {sortConfig.key === data.studentName ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.tnaRevDate)} className={css.th}>
                            Date
                            {/* {sortConfig.key === data.studentName ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>

                        {/* <th></th> */}
                    </tr>
                </thead>
                <tbody className={css.tbody}>
                    {sortedAndFilteredData.length > 0 ? (
                        sortedAndFilteredData.map((x, index) => (
                            <tr
                                key={x.tnaId}
                                id={x.tnaId}
                                onClick={() => navigate('/tna/details/' + x.tnaId)}
                                className={css.row}
                            >
                                {/* <Link to={`/tna/details/${x.tnaId}`} className={css.link}>{x.tnaId}</Link> */}
                                <td className={css.td}>{x.tnaId}</td>
                                <td className={css.td}>{x.tnaNo}</td>
                                <td className={css.td}>{x.tnaTitle}</td>
                                <td className={css.td}>{x.aircraftType}</td>
                                <td className={css.td}>{x.licenseCategory}</td>
                                <td className={css.td}>{x.tnaRev}</td>
                                <td className={css.td}>{x.tnaRevDate}</td>

                                {/* <td className={css.td}>{x.tnaTitle}</td>

                                <td className={css.tdWide} style={x.courseStart === '01-Jan-1900' ? { color: 'red' } : {}}>
                                    {toShort(x.courseStart)}
                                </td>
                                <td className={css.tdWide} style={x.courseEnd === '01-Jan-1900' ? { color: 'red' } : {}}>
                                    {toShort(x.courseEnd)}
                                </td> */}


                                {/* <td className={css.td}>{x.requestId}</td> */}

                                {/* <td className={css.td}>
                                    {x.certificateLink && (
                                        <Link to={x.certificateLink} target="_blank" rel="noopener noreferrer">
                                            <i className="fa-solid fa-award"></i>
                                        </Link>
                                    )}
                                </td> */}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                                No matching records found. Please adjust your filter.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
}

export default TnaOverview;
